import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../utils'
import { MdOutlineLightbulb } from 'react-icons/md'
import {
    BsClock,
    BsHouseDoor,
    BsShieldCheck
} from "react-icons/bs";

import {
    MdHandshake,
    MdOutlineLocationOn,
    MdOutlineHeadsetMic,
    MdOutlineGroups
} from "react-icons/md";
import { TbTarget } from 'react-icons/tb';
import director from '../assets/director.jpeg'
import team from '../assets/team.jpeg'

function AboutPage() {
    return (
        <div>
            <Helmet>
                <title>About Us - {utils.siteName}</title>
            </Helmet>
            <div className="bg-primary/5">
                <header className="px-8 mb-16 max-w-7xl mx-auto py-3">
                    <span className="block text-xs uppercase tracking-widest font-label text-secondary mb-4">Our Story</span>
                    <h1 className="text-3xl md:text-5xl font-headline text-primary max-w-3xl leading-tight">About Sage</h1>
                    <div className="w-24 h-1 bg-secondary mt-5"></div>
                </header>
            </div>
            <div className="max-w-7xl mx-auto space-y-10 mb-16 px-6">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
                    <div className="md:col-span-7">
                        <div className="relative group">
                            <div className="absolute -inset-4 bg-[#F8F9F7] rounded-xl -z-10"></div>
                            <img
                                className="w-full aspect-[4/3] z-0 object-cover object-center rounded-xl shadow-sm perspective-image"
                                alt="Sage Furnished Apartments Director - Professional portrait in modern Kisumu office setting"
                                src={director}
                            />
                        </div>
                    </div>
                    <div className="md:col-span-5 md:pl-12">
                        <span className="text-xs text-[#E87A25] uppercase tracking-widest font-label mb-2 block">
                            Leadership
                        </span>
                        <h2 className="text-4xl font-serif font-bold text-[#0F1715] mb-6">
                            Meet Our Director
                        </h2>
                        <p className="text-[#6B7C76] leading-relaxed text-lg mb-6">
                            Founded in 2021 by Portia, Sage Furnished Apartments was born from a simple vision:
                            to offer travelers and locals in Kisumu a place that feels like home — comfortable, convenient,
                            and genuinely welcoming.
                        </p>
                        <p className="text-[#6B7C76] leading-relaxed text-lg">
                            With a background in hospitality and deep roots in the Kisumu community, Portia
                            personally oversees every detail, from property curation to guest experience — ensuring
                            that every stay reflects our commitment to comfort, integrity, and local expertise.
                        </p>
                    </div>
                </div>
                <section className="py-10 bg-white">
                    <div className="">
                        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
                            <div className="md:col-span-5 md:order-1 order-2 md:pr-12 text-right">
                                <span className="text-xs text-[#E87A25] uppercase tracking-widest font-label mb-2 block">
                                    Our Team
                                </span>
                                <h2 className="text-4xl font-serif font-bold text-[#0F1715] mb-6">
                                    Dedicated to Excellence
                                </h2>
                                <p className="text-[#6B7C76] leading-relaxed text-lg mb-6">
                                    Behind every seamless stay is a team that cares. Our staff are trained in meticulous
                                    housekeeping, proactive maintenance, and warm, personalized service.
                                </p>
                                <p className="text-[#6B7C76] leading-relaxed text-lg">
                                    From daily linen changes to deep-cleaning protocols, we maintain the highest standards
                                    of cleanliness and hygiene. Because when you're away from home, you deserve a space
                                    that's not just beautiful — but truly spotless.
                                </p>
                            </div>
                            <div className="md:col-span-7 md:order-2 order-1">
                                <div className="relative group">
                                    <div className="absolute -inset-4 bg-[#F8F9F7] rounded-xl -z-10"></div>
                                    <img
                                        className="w-full aspect-[4/3] z-0 object-cover rounded-xl shadow-sm perspective-image-reverse"
                                        alt="Sage Apartments housekeeping team preparing a immaculately clean apartment with fresh linens and natural light"
                                        src={team}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <section className="">
                    <div className="grid md:grid-cols-2 gap-8">
                        <div className="bg-white p-8 md:p-10 rounded-2xl border border-[#E5E7EB] shadow-sm">
                            <div className="w-12 h-12 rounded-full bg-[#1B4D3E]/10 flex items-center justify-center text-[#1B4D3E] mb-6">
                                <MdOutlineLightbulb className="text-2xl" />
                            </div>
                            <h2 className="font-serif text-2xl font-bold text-[#0F1715] mb-4">Our Mission</h2>
                            <p className="text-[#6B7C76] leading-relaxed">
                                To become the preferred choice for comfortable, flexible lodging solutions for travelers and tourists,
                                driving consistent growth and innovation in the short-term and long-term rental market.
                            </p>
                        </div>

                        <div className="bg-white p-8 md:p-10 rounded-2xl border border-[#E5E7EB] shadow-sm">
                            <div className="w-12 h-12 rounded-full bg-[#E87A25]/10 flex items-center justify-center text-[#E87A25] mb-6">
                                <TbTarget className="text-2xl" />
                            </div>
                            <h2 className="font-serif text-2xl font-bold text-[#0F1715] mb-4">Our Vision</h2>
                            <p className="text-[#6B7C76] leading-relaxed">
                                To propel furnished apartments, sales, and consulting services across Kenya — expanding into major cities,
                                integrating smart technology, and building loyalty programs that keep guests coming back.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="py-10 bg-white">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <span className="block text-xs uppercase tracking-widest font-label text-secondary mb-4">What Drives Us</span>
                            <h2 className="text-3xl md:text-5xl font-headline text-primary max-w-3xl leading-tight mx-auto">Our Core Pillars</h2>
                            <div className="w-24 h-1 bg-secondary mt-5 mx-auto"></div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                            {[
                                {
                                    icon: <BsHouseDoor />,
                                    title: "Comfort & Convenience",
                                    desc: "Meticulously maintained spaces with fully equipped kitchens, smart home features, and free high-speed Wi-Fi."
                                },
                                {
                                    icon: <MdHandshake />,
                                    title: "Integrity & Transparency",
                                    desc: "Honest pricing, clear policies, and fair treatment for every guest and partner."
                                },
                                {
                                    icon: <MdOutlineLocationOn />,
                                    title: "Local Expertise",
                                    desc: "Deep roots in Kisumu. We share insider tips, support local artisans, and partner with community businesses."
                                },
                                {
                                    icon: <MdOutlineHeadsetMic />,
                                    title: "Dedicated Service",
                                    desc: "24/7 concierge support, seamless check-in, and a team that treats your stay like their own."
                                },
                                {
                                    icon: <BsShieldCheck />,
                                    title: "Safety & Security",
                                    desc: "CCTV, smoke alarms, fire extinguishers, 24-hour guard security, and safety deposit boxes."
                                },
                                {
                                    icon: <MdOutlineGroups />,
                                    title: "Community Commitment",
                                    desc: "Minimizing environmental impact while uplifting the neighborhoods we operate in."
                                }
                            ].map((pillar, i) => (
                                <div key={i} className="p-6 rounded-2xl bg-[#FAFAFA] border border-[#E5E7EB]/50 hover:border-[#E87A25]/30 transition-all duration-300 group">
                                    <div className="w-10 h-10 rounded-lg bg-[#1B4D3E]/10 text-[#1B4D3E] flex items-center justify-center mb-4 group-hover:bg-[#E87A25]/10 group-hover:text-[#E87A25] transition-colors">
                                        <div className="text-xl">{pillar.icon}</div>
                                    </div>
                                    <h3 className="font-serif text-lg font-bold text-[#0F1715] mb-2">{pillar.title}</h3>
                                    <p className="text-sm text-[#6B7C76] leading-relaxed">{pillar.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="py-10">
                    <div className="">
                        <div className="text-center mb-16">
                            <span className="block text-xs uppercase tracking-widest font-label text-secondary mb-4">Transparency & Trust</span>
                            <h2 className="text-3xl md:text-5xl font-headline text-primary max-w-3xl leading-tight mx-auto">Policies & Safety Standards</h2>
                            <div className="w-24 h-1 bg-secondary mt-5 mx-auto"></div>
                        </div>

                        <div className="grid md:grid-cols-2 gap-8">
                            <div className="bg-white p-8 rounded-2xl border border-[#E5E7EB] shadow-sm">
                                <h3 className="font-serif text-xl font-bold text-[#0F1715] mb-6 flex items-center gap-2">
                                    <BsClock className="text-[#E87A25]" /> Guest Policies
                                </h3>
                                <ul className="space-y-4 text-sm text-[#6B7C76]">
                                    <li className="flex justify-between border-b border-[#E5E7EB] pb-3">
                                        <span>Check-in</span><span className="font-medium text-[#0F1715]">From 12:00 PM</span>
                                    </li>
                                    <li className="flex justify-between border-b border-[#E5E7EB] pb-3">
                                        <span>Check-out</span><span className="font-medium text-[#0F1715]">5:00 AM – 10:00 AM</span>
                                    </li>
                                    <li className="flex justify-between border-b border-[#E5E7EB] pb-3">
                                        <span>Pets</span><span className="font-medium text-[#0F1715]">Not allowed</span>
                                    </li>
                                    <li className="flex justify-between border-b border-[#E5E7EB] pb-3">
                                        <span>Payment</span><span className="font-medium text-[#0F1715]">M-Pesa, Cash, Bank Transfer</span>
                                    </li>
                                    <li className="flex justify-between">
                                        <span>ID Requirement</span><span className="font-medium text-[#0F1715]">Valid ID at check-in</span>
                                    </li>
                                </ul>
                            </div>

                            <div className="bg-white p-8 rounded-2xl border border-[#E5E7EB] shadow-sm">
                                <h3 className="font-serif text-xl font-bold text-[#0F1715] mb-6 flex items-center gap-2">
                                    <BsShieldCheck className="text-[#E87A25]" /> Safety & Security
                                </h3>
                                <div className="grid grid-cols-2 gap-4">
                                    {["Fire extinguishers", "Smoke alarms", "CCTV (common areas)", "24hr guard security", "Security alarms", "Safety deposit boxes"].map((item, i) => (
                                        <div key={i} className="flex items-center gap-2 text-sm text-[#6B7C76]">
                                            <span className="text-[#1B4D3E]">✓</span> {item}
                                        </div>
                                    ))}
                                </div>
                                <div className="mt-6 p-4 bg-[#F8F9F7] rounded-lg text-xs text-[#6B7C76] leading-relaxed">
                                    <span className="font-semibold text-[#0F1715]">Note:</span> All special requests are subject to availability.
                                    Additional charges may apply. We continuously improve check-in processes through new technology.
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    )
}

export default AboutPage